import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo, useState } from 'react';
import { createOrganizer, updateOrganizer } from '../redux/slices/organizersSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import validator from 'validator';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
//import CardMedia from '@mui/material/CardMedia';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Chip from '@mui/material/Chip';
import { nanoid } from 'nanoid';

const empty = (value) => validator.isEmpty(value, { ignore_whitespace: true });
const TICKET_TYPE_LABEL_MAX_LENGTH = 128;

function OrganizerDrawer({ open, onClose, organizer }) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.organizers.isLoading);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [name, setName] = useState('');
  const [comission, setComission] = useState('');
  const [notificationSmsPrice, setNotificationSmPrice] = useState('');
  const [notificationEmailPrice, setNotificationEmailPrice] = useState('');
  const [comissionError, setComissionError] = useState(false);
  const [smsPriceError, setSmsPriceError] = useState(false);
  const [emailPriceError, setEmailPriceError] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [taxCode, setTaxCode] = useState('');
  const [regCode, setRegCode] = useState('');
  const [isVatPayer, setIsVatPayer] = useState(false);
  const [isFiscalSerialUnique, setIsFiscalSerialUnique] = useState(false);
  const [isZeroPriceFiscalized, setIsZeroPriceFiscalized] = useState(false);
  const [reprName, setReprName] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [county, setCounty] = useState('');
  const [fiscalPrefix, setFiscalPrefix] = useState('');
  const [contractId, setContractId] = useState('');
  const [seatPrice, setSeatPrice] = useState('');
  const [freeSeatPrice, setFreeSeatPrice] = useState('');
  const [cancelSeatPrice, setCancelSeatPrice] = useState('');
  const [seatPriceError, setSeatPriceError] = useState(false);
  const [freeSeatPriceError, setFreeSeatPriceError] = useState(false);
  const [cancelSeatPriceError, setCancelSeatPriceError] = useState(false);
  const [comissionPerSeat, setComissionPerSeat] = useState(false);
  const [ticketTypeLabel, setTicketTypeLabel] = useState('');
  const [ticketTypeAvailableOnline, setTicketTypeAvailableOnline] = useState(true);
  const [ticketTypeAvailableCashier, setTicketTypeAvailableCashier] = useState(true);
  const [ticketTypeDefault, setTicketTypeDefault] = useState(false);
  const [ticketTypes, setTicketTypes] = useState([]);

  const isActionDisabled = useMemo(
    () =>
      empty(name) ||
      empty(comission) ||
      empty(notificationSmsPrice) ||
      empty(notificationEmailPrice) ||
      empty(companyName) ||
      empty(taxCode) ||
      empty(reprName) ||
      empty(address) ||
      empty(city) ||
      empty(county) ||
      empty(fiscalPrefix) ||
      empty(contractId) ||
      comissionError ||
      smsPriceError ||
      emailPriceError ||
      seatPriceError ||
      freeSeatPriceError ||
      cancelSeatPriceError ||
      ticketTypes.length === 0,
    [
      name,
      comission,
      notificationSmsPrice,
      notificationEmailPrice,
      companyName,
      taxCode,
      reprName,
      address,
      city,
      county,
      fiscalPrefix,
      contractId,
      comissionError,
      smsPriceError,
      emailPriceError,
      seatPriceError,
      freeSeatPriceError,
      cancelSeatPriceError,
      ticketTypes.length,
    ]
  );

  const onDrawerClose = () => {
    onClose();
    setName('');
    setSelectedStatus('');
    setComission('');
    setNotificationSmPrice('');
    setNotificationEmailPrice('');
    setCompanyName('');
    setTaxCode('');
    setTaxCode('');
    setReprName('');
    setAddress('');
    setCity('');
    setCounty('');
    setFiscalPrefix('');
    setContractId('');
    setComissionError(false);
    setSmsPriceError(false);
    setEmailPriceError(false);
    setIsVatPayer(false);
    setIsFiscalSerialUnique(false);
    setIsZeroPriceFiscalized(false);
    setSeatPrice('');
    setSeatPriceError(false);
    setFreeSeatPrice('');
    setFreeSeatPriceError(false);
    setCancelSeatPrice('');
    setCancelSeatPriceError(false);
    setComissionPerSeat(false);
    setTicketTypeLabel('');
    setTicketTypeAvailableOnline(true);
    setTicketTypeAvailableCashier(true);
    setTicketTypeDefault(false);
    setTicketTypes([]);
  };

  const onUpdateComission = (event) => {
    setComissionError(false);
    const number = event.target.value;
    setComission(number);
    if (number === '' || !(Number.isInteger(+number) && number >= 0 && number <= 100)) {
      setComissionError(true);
    }
  };

  const onUpdateSmsPrice = (event) => {
    setSmsPriceError(false);
    const number = event.target.value;
    setNotificationSmPrice(number);
    if (!validator.isDecimal(number, { decimal_digits: '0,2' })) {
      setSmsPriceError(true);
    }
  };

  const onUpdateEmailPrice = (event) => {
    setEmailPriceError(false);
    const number = event.target.value;
    setNotificationEmailPrice(number);
    if (!validator.isDecimal(number, { decimal_digits: '0,2' })) {
      setEmailPriceError(true);
    }
  };

  const onUpdateSeatPrice = (event) => {
    setSeatPriceError(false);
    const number = event.target.value;
    setSeatPrice(number);

    if (!validator.isDecimal(number, { decimal_digits: '0,2' })) {
      setSeatPriceError(true);
    }
  };

  const onUpdateFreeSeatPrice = (event) => {
    setSeatPriceError(false);
    const number = event.target.value;
    setFreeSeatPrice(number);

    if (!validator.isDecimal(number, { decimal_digits: '0,2' })) {
      setFreeSeatPriceError(true);
    }
  };

  const onUpdateCancelSeatPrice = (event) => {
    setSeatPriceError(false);
    const number = event.target.value;
    setCancelSeatPrice(number);

    if (!validator.isDecimal(number, { decimal_digits: '0,2' })) {
      setCancelSeatPriceError(true);
    }
  };

  const addTicketType = () => {
    const label = ticketTypeLabel.trim();
    if (!label) {
      return;
    }

    setTicketTypes((current) => [
      ...current.map((ticketType) => ({
        ...ticketType,
        default: ticketTypeDefault ? false : ticketType.default,
      })),
      {
        id: nanoid(),
        label,
        available_online: ticketTypeAvailableOnline,
        available_cashier: ticketTypeAvailableCashier,
        default: ticketTypeDefault,
      },
    ]);
    setTicketTypeLabel('');
    setTicketTypeAvailableOnline(true);
    setTicketTypeAvailableCashier(true);
    setTicketTypeDefault(false);
  };

  const removeTicketType = (id) => {
    setTicketTypes((current) => current.filter((ticketType) => ticketType.id !== id));
  };

  useEffect(() => {
    if (organizer) {
      const {
        name,
        status,
        platform_comission,
        seat_price,
        free_seat_price,
        cancel_seat_price,
        notification_sms_price,
        notification_email_price,
        is_fiscal_serial_unique,
        is_zero_price_fiscalized,
        comission_cash_per_seat,
        companies,
        ticket_types,
      } = organizer;

      const {
        company_name,
        tax_code,
        reg_code,
        is_vat_payer,
        address,
        city,
        county,
        representative_full_name,
        fiscal_serial_prefix,
        contract_id,
      } = companies.find((company) => company.is_default);

      setName(name);
      setSelectedStatus(status);
      setComission((platform_comission * 100).toString());
      setNotificationSmPrice(notification_sms_price);
      setNotificationEmailPrice(notification_email_price);
      setCompanyName(company_name);
      setTaxCode(tax_code);
      setRegCode(reg_code);
      setIsVatPayer(!!is_vat_payer);
      setIsFiscalSerialUnique(!!is_fiscal_serial_unique);
      setIsZeroPriceFiscalized(!!is_zero_price_fiscalized);
      setAddress(address);
      setCity(city);
      setCounty(county);
      setReprName(representative_full_name);
      setFiscalPrefix(fiscal_serial_prefix);
      setContractId(contract_id);
      setSeatPrice(seat_price || '');
      setFreeSeatPrice(free_seat_price || '');
      setCancelSeatPrice(cancel_seat_price || '');
      setComissionPerSeat(!!comission_cash_per_seat);
      setTicketTypes(
        (ticket_types || []).map(({ id, label, available_online, available_cashier, default: isDefault }, index) => ({
          id: id || `ticket-type-${index}`,
          label,
          available_online: !!available_online,
          available_cashier: !!available_cashier,
          default: !!isDefault,
        }))
      );
    }
  }, [organizer]);

  const onCreateOrganizer = () => {
    const payload = {
      name: name.trim(),
      organizer_pricing: {
        comission_cash_per_seat: comissionPerSeat,
        comission,
        seat_price: seatPrice,
        free_seat_price: freeSeatPrice,
        cancel_seat_price: cancelSeatPrice,
        notifications_sms_price: notificationSmsPrice,
        notifications_email_price: notificationEmailPrice,
        is_fiscal_serial_unique: isFiscalSerialUnique,
        is_zero_price_fiscalized: isZeroPriceFiscalized,
      },
      company: {
        name: companyName,
        tax_code: taxCode,
        reg_code: regCode,
        is_vat_payer: isVatPayer,
        address,
        city,
        county,
        representative_full_name: reprName,
        fiscal_serial_prefix: fiscalPrefix,
        contract_id: contractId,
      },
      ticket_types: ticketTypes.map(({ label, available_online, available_cashier, default: isDefault }) => ({
        label,
        available_online,
        available_cashier,
        default: isDefault,
      })),
    };
    dispatch(createOrganizer(payload)).then(({ payload }) => {
      if (payload) {
        toast.success(t('Organizer created successfuly'), { position: toast.POSITION.BOTTOM_RIGHT });
        onDrawerClose();
      }
    });
  };

  const onUpdateOrganizer = () => {
    const payload = {
      organizerId: organizer.id,
      status: selectedStatus,
      name: name.trim(),
      organizer_pricing: {
        comission_cash_per_seat: comissionPerSeat,
        comission,
        seat_price: seatPrice,
        free_seat_price: freeSeatPrice,
        cancel_seat_price: cancelSeatPrice,
        notifications_sms_price: notificationSmsPrice,
        notifications_email_price: notificationEmailPrice,
        is_fiscal_serial_unique: isFiscalSerialUnique,
        is_zero_price_fiscalized: isZeroPriceFiscalized,
      },
      company: {
        name: companyName,
        tax_code: taxCode,
        reg_code: regCode,
        is_vat_payer: isVatPayer,
        address,
        city,
        county,
        representative_full_name: reprName,
        fiscal_serial_prefix: fiscalPrefix,
        contract_id: contractId,
      },
      ticket_types: ticketTypes.map(({ id, label, available_online, available_cashier, default: isDefault }) => ({
        ...(typeof id === 'number' ? { id } : {}),
        label,
        available_online,
        available_cashier,
        default: isDefault,
      })),
    };
    dispatch(updateOrganizer(payload)).then(({ payload }) => {
      if (payload) {
        toast.success(t('Organizer updated successfuly'), { position: toast.POSITION.BOTTOM_RIGHT });
        onDrawerClose();
      }
    });
  };

  return (
    <Drawer anchor="right" open={open}>
      <Toolbar />
      <Toolbar>
        <Typography variant="button">{!organizer ? t('Create organizer') : t('Edit organizer')}</Typography>
      </Toolbar>
      <Divider />
      <Box sx={{ width: 400, pl: 2, pr: 2 }}>
        <Box sx={{ pb: 3 }} component="form">
          <TextField
            required
            value={name}
            onChange={(event) => setName(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Name')}
            type="text"
          />
          {organizer && (
            <TextField
              select
              value={selectedStatus}
              onChange={(event) => setSelectedStatus(event.target.value)}
              fullWidth
              variant="standard"
              margin="normal"
              size="small"
              label={t('Status')}
            >
              <MenuItem value={'ACTIVE'}>{t('ACTIVE')}</MenuItem>
              <MenuItem value={'INACTIVE'}>{t('INACTIVE')}</MenuItem>
            </TextField>
          )}
        </Box>
        <Box sx={{ pb: 3 }} component="form">
          <Typography gutterBottom variant="button">
            {t('Pricing')}
          </Typography>
          <TextField
            required
            value={comission}
            onChange={onUpdateComission}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Comission (%)')}
            type="text"
          />
          <TextField
            value={seatPrice}
            onChange={onUpdateSeatPrice}
            fullWidth
            required
            variant="standard"
            margin="normal"
            size="small"
            label={t('Seat price (Lei)')}
            type="text"
          />
          <TextField
            value={freeSeatPrice}
            onChange={onUpdateFreeSeatPrice}
            fullWidth
            required
            variant="standard"
            margin="normal"
            size="small"
            label={t('Free seat price (Lei)')}
            type="text"
          />
          <TextField
            value={cancelSeatPrice}
            onChange={onUpdateCancelSeatPrice}
            fullWidth
            required
            variant="standard"
            margin="normal"
            size="small"
            label={t('Cancel seat price (Lei)')}
            type="text"
          />
          <FormGroup sx={{ mt: 2 }}>
            <FormControlLabel
              control={
                <Switch checked={comissionPerSeat} onChange={(event) => setComissionPerSeat(event.target.checked)} />
              }
              label={t('Comission cash per seat')}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={isFiscalSerialUnique}
                  onChange={(event) => setIsFiscalSerialUnique(event.target.checked)}
                />
              }
              label={t('Unique Fiscal Serial')}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={isZeroPriceFiscalized}
                  onChange={(event) => setIsZeroPriceFiscalized(event.target.checked)}
                />
              }
              label={t('Price zero fiscalization')}
            />
          </FormGroup>
          <TextField
            required
            value={notificationSmsPrice}
            onChange={onUpdateSmsPrice}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Sms price (Lei)')}
            type="text"
          />
          <TextField
            required
            value={notificationEmailPrice}
            onChange={onUpdateEmailPrice}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Email price (Lei)')}
            type="text"
          />
        </Box>
        <Box component="form">
          <Typography gutterBottom variant="button">
            {t('Company')}
          </Typography>
          <TextField
            required
            value={companyName}
            onChange={(event) => setCompanyName(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={'Company name'}
            type="text"
          />
          <TextField
            required
            value={reprName}
            onChange={(event) => setReprName(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Representative full name')}
            type="text"
          />
          <TextField
            required
            value={taxCode}
            onChange={(event) => setTaxCode(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Tax code')}
            type="text"
          />
          <TextField
            value={regCode}
            onChange={(event) => setRegCode(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Reg. code')}
            type="text"
          />
          <FormGroup sx={{ mt: 2 }}>
            <FormControlLabel
              control={<Switch checked={isVatPayer} onChange={(event) => setIsVatPayer(event.target.checked)} />}
              label={t('VAT Payer')}
            />
          </FormGroup>
          <TextField
            required
            value={address}
            onChange={(event) => setAddress(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Address')}
            type="text"
          />
          <TextField
            required
            value={city}
            onChange={(event) => setCity(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('City')}
            type="text"
          />
          <TextField
            required
            value={county}
            onChange={(event) => setCounty(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('County')}
            type="text"
          />
          <TextField
            required
            value={fiscalPrefix}
            onChange={(event) => setFiscalPrefix(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Fiscal serial prefix')}
            type="text"
          />
          <TextField
            required
            value={contractId}
            onChange={(event) => setContractId(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Contract ID')}
            type="text"
          />
        </Box>
        <Box sx={{ pt: 3 }}>
          <Typography variant="button">{t('Ticket types')}</Typography>
          <TextField
            required
            value={ticketTypeLabel}
            onChange={(event) => setTicketTypeLabel(event.target.value)}
            fullWidth
            variant="standard"
            margin="normal"
            size="small"
            label={t('Label')}
            type="text"
            inputProps={{ maxLength: TICKET_TYPE_LABEL_MAX_LENGTH }}
            helperText={t('Characters: {{count}}/{{max}}', {
              count: ticketTypeLabel.length,
              max: TICKET_TYPE_LABEL_MAX_LENGTH,
            })}
          />
          <FormGroup sx={{ mt: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={ticketTypeAvailableOnline}
                  onChange={(event) => setTicketTypeAvailableOnline(event.target.checked)}
                />
              }
              label={t('Available online')}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={ticketTypeAvailableCashier}
                  onChange={(event) => setTicketTypeAvailableCashier(event.target.checked)}
                />
              }
              label={t('Available at cashier')}
            />
            <FormControlLabel
              control={
                <Switch checked={ticketTypeDefault} onChange={(event) => setTicketTypeDefault(event.target.checked)} />
              }
              label={t('Default')}
            />
          </FormGroup>
          <Button disabled={empty(ticketTypeLabel)} onClick={addTicketType} fullWidth variant="text" size="small">
            {t('Add')}
          </Button>
          <List>
            {ticketTypes.map((ticketType) => (
              <ListItem key={ticketType.id} divider>
                <ListItemText
                  sx={{ pr: 6 }}
                  primary={
                    <>
                      {ticketType.label}
                      {ticketType.default && <Chip sx={{ ml: 1 }} size="small" label={t('Default')} />}
                    </>
                  }
                  secondary={[ticketType.available_online && t('Online'), ticketType.available_cashier && t('Cashier')]
                    .filter(Boolean)
                    .join(', ')}
                />
                <ListItemSecondaryAction>
                  <IconButton onClick={() => removeTicketType(ticketType.id)} edge="end" aria-label="delete">
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
      <Box sx={{ p: 2, mt: 'auto' }}>
        <Grid columnSpacing={2} container>
          <Grid xs={6} item>
            <Button fullWidth variant="outlined" onClick={onDrawerClose}>
              {t('Cancel')}
            </Button>
          </Grid>
          <Grid xs={6} item>
            <Button
              disabled={isLoading || isActionDisabled}
              fullWidth
              variant="contained"
              onClick={!organizer ? onCreateOrganizer : onUpdateOrganizer}
            >
              {!organizer ? t('Create') : t('Update')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
}

export default OrganizerDrawer;
